import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PlanogramApiService } from 'src/app/services/planogram-api.service';
import { SignalRService } from 'src/app/services/signalr.service';
import { FolderPlanogramState } from 'src/app/models/folder';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-load-modal',
    templateUrl: './load-modal.component.html',
    styleUrls: ['./load-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, DatePipe]
})
export class LoadModalComponent implements OnInit {
  public states: FolderPlanogramState[] = [];
  public isLoading = true;
  selectedStateId: string | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private planogramApiService: PlanogramApiService,
    private signalRService: SignalRService,
  ) { }

  ngOnInit(): void {
    this.planogramApiService.getPlanogramStates().subscribe(stateList => {
      if (stateList) {
        this.states = stateList.states.sort((a, b) => 
          new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime()
        );
      }
      this.isLoading = false;
    });
  }

  confirm(): void {
    if (this.selectedStateId) {
      this.signalRService.loadPlanogramState(this.selectedStateId);
      this.activeModal.close(this.selectedStateId);
    }
  }

  cancel(): void{
    this.activeModal.close(null);
  }
}
